import React from "react";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * Pulsante "Continua con Google" — usa Emergent Google Auth.
 * Redireziona a auth.emergentagent.com e fa tornare su /auth/google/callback#session_id=...
 */
export default function GoogleLoginButton({ testId = "google-login-btn", label = "Continua con Google" }) {
  const onClick = () => {
    const redirectUrl = window.location.origin + "/auth/google/callback";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="w-full h-12 rounded-2xl border border-outline bg-white hover:bg-gold-light text-ink-800 font-bold flex items-center justify-center gap-3 shadow-tactile transition-all"
    >
      <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35.5 24 35.5c-6.4 0-11.5-5.1-11.5-11.5S17.6 12.5 24 12.5c2.9 0 5.6 1.1 7.7 2.9l5.7-5.7C33.9 6.4 29.2 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5c10.9 0 19.5-8.7 19.5-19.5 0-1.2-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c2.9 0 5.6 1.1 7.7 2.9l5.7-5.7C33.9 7 29.2 5 24 5 16.3 5 9.6 9.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 43.5c5.1 0 9.8-1.9 13.3-5l-6.1-5c-2 1.4-4.5 2.2-7.2 2.2-5.2 0-9.6-3.5-11.2-8.2l-6.5 5C9.6 38.6 16.2 43.5 24 43.5z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4-4 5.4l6.1 5c-.4.4 6.6-4.8 6.6-14.4 0-1.2-.1-2.3-.4-3.5z"/>
      </svg>
      {label}
    </button>
  );
}
